import Link from 'next/link';


interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  const currentYear = new Date().getFullYear();

  const navigationLinks = [
    { label: 'Home', href: '/' },
    { label: 'About Nikola', href: '/about-nikola-broceta' },
    { label: 'Career', href: '/career' },
    { label: 'Media & Mentions', href: '/media-mentions' },
  ];

  const professionalLinks = [
    { label: 'Professional Inquiries', href: '/contact' },
    { label: 'Disclaimer', href: '/disclaimer' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Regulatory Compliance', href: '/compliance' },
  ];

  // Sister projects of the Balkan Bug group (editorial cross-links, 2026-09-09).
  const projectLinks = [
    { label: 'ShowMeTrade — trading community with a public score', href: 'https://www.showmetrade.com/?utm_source=nikolabroceta.com&utm_medium=footer&utm_campaign=network' },
    { label: 'FXDoctor — trading education', href: 'https://fxdoctor.pro/?utm_source=nikolabroceta.com&utm_medium=footer&utm_campaign=network' },
    { label: 'DayProp — funded trading accounts', href: 'https://dayprop.com/?utm_source=nikolabroceta.com&utm_medium=footer&utm_campaign=network' },
    { label: 'Swiss Prime Markets — futures prop trading', href: 'https://swissprimemarkets.com/?utm_source=nikolabroceta.com&utm_medium=footer&utm_campaign=network' },
    { label: 'Predvidi.me — prediction markets', href: 'https://predvidi.me/?utm_source=nikolabroceta.com&utm_medium=footer&utm_campaign=network' },
  ];

  const socialLinks = [
    { 
      name: 'LinkedIn', 
      href: 'https://www.linkedin.com/in/nikola-broceta/',
      ariaLabel: 'Nikola Broceta LinkedIn',
      title: 'Visit Nikola Broceta on LinkedIn',
      icon: (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      )
    },
    { 
      name: 'Instagram', 
      href: 'https://www.instagram.com/fxdoctorpro/',
      ariaLabel: 'Nikola Broceta Instagram',
      title: 'Visit FX Doctor Pro on Instagram',
      icon: (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
        </svg>
      )
    },
    { 
      name: 'Facebook', 
      href: 'https://www.facebook.com/fxdoctorpro',
      ariaLabel: 'Nikola Broceta Facebook',
      title: 'Visit FX Doctor Pro on Facebook',
      icon: (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    { 
      name: 'Email', 
      href: 'mailto:nikola@broceta.com',
      ariaLabel: 'Email Nikola Broceta',
      title: 'Send email to nikola@broceta.com',
      icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    },
  ];

  return (
    <footer className={`bg-bg-1 border-t border-border mt-20 ${className}`}>
      <div className="max-w-content mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          <div className="space-y-5">
            <div className="flex flex-col">
              <span className="font-headline text-base font-semibold text-text-primary tracking-tight">
                Nikola Broceta
              </span>
              <span className="font-body text-xs text-text-muted mt-1">
                Professional Trader
              </span>
            </div>
            <p className="font-body text-sm text-text-muted leading-relaxed">
              Professional trader and risk specialist with expertise in active trading, FX markets, and institutional-grade risk management.
            </p>
          </div>

          <div>
            <h3 className="font-headline text-sm font-semibold text-text-primary mb-5 tracking-tight">
              Navigation
            </h3>
            <ul className="space-y-3">
              {navigationLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="font-body text-sm text-text-muted hover:text-accent-green transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-headline text-sm font-semibold text-text-primary mb-5 tracking-tight">
              Professional
            </h3>
            <ul className="space-y-3">
              {professionalLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="font-body text-sm text-text-muted hover:text-accent-green transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-headline text-sm font-semibold text-text-primary mb-5 tracking-tight">
              Projects
            </h3>
            <ul className="space-y-3">
              {projectLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener"
                    className="font-body text-sm text-text-muted hover:text-accent-green transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-headline text-sm font-semibold text-text-primary mb-5 tracking-tight">
              Connect
            </h3>
            <div className="flex space-x-3 mb-5">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target={social.name === 'Email' ? undefined : '_blank'}
                  rel={social.name === 'Email' ? undefined : 'noopener noreferrer'}
                  className="w-9 h-9 border border-border rounded-md flex items-center justify-center text-text-muted hover:text-accent-green hover:border-accent-green/60 hover:bg-bg-2 transition-all duration-200"
                  aria-label={social.ariaLabel}
                  title={social.title}
                >
                  {social.icon}
                </a>
              ))}
            </div>
            <p className="font-body text-xs text-text-muted leading-relaxed">
              For professional inquiries and institutional partnerships, please use the contact form.
            </p>
          </div>
        </div>

        <div className="border-t border-border pt-10">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-5 md:space-y-0 mb-8">
            <p className="font-body text-xs text-text-muted">
              © {currentYear} Nikola Broceta. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center gap-5">
              <Link
                href="/disclaimer"
                className="font-body text-xs text-text-muted hover:text-accent-green transition-colors duration-200"
              >
                Disclaimer
              </Link>
              <Link
                href="/privacy"
                className="font-body text-xs text-text-muted hover:text-accent-green transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms"
                className="font-body text-xs text-text-muted hover:text-accent-green transition-colors duration-200"
              >
                Terms of Service
              </Link>
              <Link
                href="/compliance"
                className="font-body text-xs text-text-muted hover:text-accent-green transition-colors duration-200"
              >
                Compliance
              </Link>
            </div>
          </div>
          
          <div className="pt-8 border-t border-border">
            <h3 className="font-headline text-xs font-semibold text-text-primary mb-4 tracking-tight">
              Data Verification Sources
            </h3>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="https://www.linkedin.com/in/nikola-broceta/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs text-text-muted hover:text-accent-green transition-colors duration-200"
              >
                LinkedIn Profile
              </a>
              <span className="text-border text-xs">•</span>
              <a
                href="https://about.me/broceta"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs text-text-muted hover:text-accent-green transition-colors duration-200"
              >
                About.me Profile
              </a>
              <span className="text-border text-xs">•</span>
              <a
                href="https://www.wikidata.org/wiki/Q138796838"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs text-text-muted hover:text-accent-green transition-colors duration-200"
              >
                Wikidata Entity
              </a>
            </div>
          </div>
          
          <div className="mt-8 pt-8 border-t border-border">
            <p className="font-body text-xs text-text-muted leading-relaxed">
              Regulatory Disclaimer: This website provides professional biographical information for institutional reference purposes. 
              Past performance does not guarantee future results. All investment activities are subject to applicable regulatory oversight.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;